/**
 * The application api response different error codes
 */
export const ApiErrorCodes = {
    //TODO: Add the rest of the error codes
    unAuthorized: 401 as const,
}
